const ErrorMessages = {
  loadingUserMedia: "Error loading user media",
  loadingUserDevices: "Error loading cameras and microphones"
}

export default ErrorMessages;